var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.uniqueAccessCode && !_vm.canShowPresentingScreen)?_c('div',{staticClass:"w-full h-full"},[_c('iframe',{staticClass:"sharable-iframe audience-iframe",attrs:{"src":_vm.audienceLink}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }